import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../../shared/components/ui/Button/Button';
import './styles.css';

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <div className="not-found-icon">
          <svg
            width="120"
            height="120"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
              fill="currentColor"
              opacity="0.3"
            />
          </svg>
        </div>
        
        <h1 className="not-found-title">{t('notFound.title')}</h1>
        <h2 className="not-found-subtitle">{t('notFound.subtitle')}</h2>
        <p className="not-found-message">
          {t('notFound.message')}
        </p>

        <div className="not-found-actions">
          <Button onClick={handleGoHome}>
            {t('common.goHome')}
          </Button>
        </div>
      </div>
    </div>
  );
}
